import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { APIProvider } from '@vis.gl/react-google-maps';
import { AuthProvider } from './contexts/AuthContext';
import { LoadoutProvider } from './contexts/LoadoutContext';
import { captureAcquisition } from './lib/acquisition';
import App from './App';
import './index.css';

// Capture where user came from (referrer, UTM params) on first visit
captureAcquisition();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
  },
});

// Clear the static SEO fallback inside #root before React renders, so createRoot
// doesn't warn about replacing existing children. The fallback is the static
// marketing copy in index.html (and in per-route prerendered HTML) that lets
// HTML-only crawlers (GPTBot, ClaudeBot) and slow-network users see meaningful
// content before the React app hydrates.
const rootEl = document.getElementById('root')!;
rootEl.replaceChildren();

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
          <AuthProvider>
            <LoadoutProvider>
              <App />
            </LoadoutProvider>
          </AuthProvider>
        </APIProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
